export default __webpack_public_path__ + "static/media/icon-manager.36c19621.svg";